import axios from 'axios';
import { getAppTimezone } from '@/utils/dateTime';

const API_URL = '/api/tenant/dashboard';

export const fetchDashboardSummary = async () => {
  try {
    const response = await axios.get(`${API_URL}/summary`, {
      params: { timezone: getAppTimezone() },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard summary:', error);
    throw error;
  }
};
